//
//
//
//
//
//
//
//
//
//

import ColorItem from '@/components/objects/public/shared-blocks/facts/ColorItem.vue'
import { LIST_COLORS } from "@/constants/ui.js";
import { intToHumanReadable } from "@/utils/converter.js";
import { datesToHuman } from "@/utils/dates.js";
import typo from "ru-typo";

export default {
  name: "MainFacts",
  components: { ColorItem },
  provide: {
    source: 'list'
  },

  props: {
    palette: {
      type: Object,
    },
  },

  data() {
    return {
      factsViewCount: 6,
      colors: [...LIST_COLORS],
    }
  },

  computed: {
    mainFacts() {
      return this.$store.getters['objects/getMainFacts'];
    },
    slicedMainFacts() {
      return this.mainFacts.slice(0, this.factsViewCount)
    },
    siTypes() {
      return (this.$store.state.property_templates.consts.si ?? [])
    },
    coloredItems() {
      const items = this.slicedMainFacts.map((fact, index) => {
        const factItem = fact.items[0]
        const item = JSON.parse(JSON.stringify(factItem))
        item.id = `${factItem.id}_${index}`
        item.color = this.getColor(index)
        item.humanReadableValue = this.buildHumanReadable(factItem.value)
        item.descriptionFontSize = `${this.computeDescrFontSize(factItem.description)}px`
        item.description = typo(factItem.description, { hyphens: true })
        item.category = {
          id: fact.id,
          label: fact.label
        }
        item.vistatObject = {
          id: factItem.vistat_object_annotated.slug ?? factItem.vistat_object_annotated.id,
          label: factItem.vistat_object_annotated.label
        }
        return item
      })

      return items
    },
    myPalette() {
      if (this.palette) {
        const palette = this.$store.state["property_templates"]["consts"].palette;
        if (palette) {
          return palette.filter(el => el.id === this.palette)[0];
        }
      }

      const palette = this.$store.state["property_templates"]["consts"].palette;

      if (palette) {
        return palette.filter(el => el.id === 'Pal007')[0];
      }

      return null;
    },
  },

  mounted() {
    this.updateFactsViewCount()

    window.addEventListener('resize', this.updateFactsViewCount, { passive: true })
  },

  destroyed() {
    window.removeEventListener('resize', this.updateFactsViewCount)
  },

  methods: {
    updateFactsViewCount() {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 1200) {
          this.factsViewCount = 8
        } else {
          this.factsViewCount = 6
        }
      }
    },
    getColor(index) {
      if (this.myPalette) {
        const palette = [this.myPalette.main_color, ...this.myPalette.colors];
        return palette[index % palette.length];
      } else {
        return this.colors[index % this.colors.length];
      }
    },
    buildHumanReadable(value) {
      switch (value.type) {
      case "number":
        const si = value.si ? this.siTypes.find(x => x.id === value.si) : null
        const numberVal = [intToHumanReadable(value.data), si ? si : null]
        const numberValText = numberVal[0].replace(/<[^>]*>/g, ' ') + (numberVal[1]?.si ? numberVal[1].si : '')

        return {
          val: numberVal,
          style: {
            'font-size': `${this.computeValFontSize(numberValText)}px`
          }
        }
      case "date":
        const dateVal = datesToHuman({ value: value.data.vfrom?.value || value.data.vfrom }, { value: value.data.vto?.value || value.data.vto }, 'object')
        const dateValText = dateVal.join(' ')

        return {
          val: dateVal,
          style: {
            'font-size': `${this.computeValFontSize(dateValText)}px`
          }
        }
      default:
        return {
          val: [value.data],
          style: {
            'font-size': `${this.computeValFontSize(value.data)}px`
          }
        }
      }
    },
    computeDescrFontSize(descr = "") {
      const length = descr.length;

      if (length <= 60) return 12
      // else if (length < 70) return 11
      else if (length < 80) return 11
      else if (length < 100) return 10
      else if (length < 125) return 9
      return 8
    },
    computeValFontSize(descr = "") {
      const length = descr.length;

      if (length <= 20) return 13
      else if (length < 30) return 12
      return 11
    },
  }
}
